<template>
  <div class="tips-section">
    <div class="tips-reason-header">
      <div class="main-header">
        <div class="header-decoration">
          <span class="decoration-text">＼ 知らないと損する！ポイントを解説 ／</span>
        </div>
        <h2 class="main-title">給湯器を安く設置するコツ</h2>
      </div>

      <div class="intro-section">
        <div class="intro-text">
          <div class="speech-bubble">
            必ず複数業者に<br>見積もりを依頼しよう！
          </div>
        </div>
        <div class="intro-title-img">
          <img src="../../assets/vendor.png" alt="">
        </div>
      </div>
    </div>

    <div class="content-card">
      <div class="reason-header">
        <div class="reason-label">理由1</div>
        <h4 class="reason-title">最安値の業者を選べる！</h4>
      </div>
      <div class="price-comparison-img-block">
        <img src="../../assets/tips/1.png" alt="">
      </div>

      <div class="explanation-text-box">
        <p>
          業者によって提示される金額には、大きな差が生じることが少なくありません。</p>
        <p>同じ給湯器の設置工事でも、A社では高額、B社では割安というケースはよくあります。</p>
        <p>そのため、<span class="bold-red">できれば最低でも3社以上から見積もりを取り</span>、しっかり比較・検討することが大切です。</p>
        <p>複数の見積もりを照らし合わせることで、<span class="under-yellow">相場感を把握できると同時に、最安値の業者を見つけることができます。</span></p>
      </div>
    </div>

    <div class="content-card" style="margin-top: 30px;">
      <div class="reason-header">
        <div class="reason-label">理由2</div>
        <h4 class="reason-title">サービスの違いを比較できる！</h4>
      </div>
      <div class="price-comparison-img-block-2">
        <img src="../../assets/tips/3.png" alt="">
      </div>

      <div class="explanation-text-box">
        <p>
          金額だけでなく、<span class="bold-red">保証内容・施工スピード・アフターサポート</span>といった条件は、業者によって大きく異なります。</p>
        <p>たとえば「料金は安いけれど保証が短い業者」もあれば、「費用はやや高めでもサポート体制が充実している業者」もあります。</p>
        <p>複数社を比較することで、それぞれの特徴を比較して、<span class="under-yellow">自分の希望や生活スタイルに最も合った業者を選択</span>できるようになります。</p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.tips-section {
  max-width: 600px;
  margin: 0 auto;
  color: #333;
  padding-bottom: 20px;
  box-sizing: border-box;
  background: #fffafa;
  margin-top: 20px;
}

.main-header {
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
  background: #3f51b5;
  position: relative;
  color: #fff;
  border-radius: 15px 15px 0 0;
}

.decoration-text {
  font-size: 1.3rem;
  color: #ffeb3b;
  font-weight: bold;
  display: inline-block;
}

.main-title {
  font-size: 1.9rem;
  font-weight: bold;
  margin: 0;
  line-height: 1.2;
}

.intro-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.intro-section img {
  width: 100%;
}

.person-illustration-intro {
  width: 150px;
  height: 150px;
}

.speech-bubble {
  position: relative;
  background: #fff;
  font-weight: bold;
  font-size: 1.5rem;
  padding: 15px 20px;
  border-radius: 10px;
  line-height: 1.5;
  max-width: 300px;
  border: 2px solid #2c387e;
}

.speech-bubble::after {
  content: "";
  position: absolute;
  top: 50%;
  right: -21px;
  transform: translateY(-50%);
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent transparent black;
}

.content-card {
  padding: 0 20px 20px;
  background-color: #fff;
  margin: 30px;
  margin-top: 0;
  border: 1px solid #ddd;
}

.reason-header {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: #3498db;
  padding: 10px 15px;
  margin: 0 -20px 0;
}

.reason-label {
  background-color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: bold;
}

.reason-title {
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  margin: 0;
}

.price-group {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 5px;
  position: relative;
  padding: 0 20px;
}

.person-icon-container {
  width: 80px;
  height: 80px;
  background-color: white;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}

.person-icon {
  width: 50px;
  height: 50px;
}

.price-item {
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 15px;
  border-radius: 8px;
  font-weight: bold;
  color: #333;
}

.price-group.a-sha .price-item {
  background-color: #d3d3d3;
}

.price-group.b-sha .price-item {
  background-color: #89e27c;
  color: #fff;
  flex-grow: 0.5;
}

.price-group.c-sha .price-item {
  flex-grow: 0.8;
}

.b-sha,
.c-sha {
  margin-top: -20px;
}

.price-group.c-sha .price-item {
  background-color: #d3d3d3;
}

.company-name {
  font-size: 1.1rem;
}

.price {
  font-size: 1.2rem;
}

.cheapest-label {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  background-color: #e74c3c;
  color: white;
  font-size: 0.9rem;
  font-weight: bold;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  width: 90px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
}

.explanation-text-box {
  text-align: left;
  padding: 15px;
}

.intro-title-img {
  width: 30%;
}

.intro-title {
  font-size: 30px;
  margin-top: 50px;
}

.explanation-text {
  font-size: 0.9rem;
  line-height: 1.6;
  color: #555;
  margin: 0;
}

.highlight {
  color: #e74c3c;
  font-weight: bold;
}

.price-comparison-img-block img {
  width: 90%;
  margin: 20px;
  margin-bottom: 0;
}

.price-comparison-img-block-2 img {
  width: 50%;
  margin-bottom: 0;
  padding: 0;
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 600px) {
  .decoration-text {
    font-size: 1.2rem;
  }

  .main-title {
    font-size: 1.5rem;
  }

  .speech-bubble {
    font-size: 1.3rem;
    margin: 5px;
    padding: 15px;
  }

  .reason-label {
    font-size: 0.9rem;
  }

  .reason-title {
    font-size: 1.1rem;
  }

  .reason-header {
    padding: 15px 20px;
  }

  .price-comparison-img-block img {
    width: 95%;
  }

  .explanation-text-box {
    font-size: 1rem;
  }

  .content-card {
    margin: 15px;
  }

  .price-comparison-img-block img {
    widows: 99%;
    margin: 0;
    margin-top: 10px;
  }
}

/* ==================== スマホ対応 ==================== */
@media (max-width: 480px) {
  .decoration-text {
    font-size: 1rem;
  }

  .main-title {
    font-size: 1.3rem;
  }

  .speech-bubble {
    font-size: 1rem;
    margin: 5px;
    padding: 15px;
  }

  .reason-label {
    font-size: 0.7rem;
  }

  .reason-title {
    font-size: 1rem;
  }

  .reason-header {
    padding: 15px 20px;
  }

  .explanation-text-box {
    padding: 0;
    font-size: 0.9rem;
  }

  .content-card {
    margin: 7px;
  }
}
</style>
